module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABZUlEQVR42u3aPUsDQRDG8ftqdmJhY2drb+9HsJAgBLFRKzvBXsTCFCJoY+dLcpEgIXoqAU8Nvow8C6dGOUXEW9z9DwyEm7nA/tjZC0cSM0tizgQAAAAAAAAAAAAAAAAiBxiZbVpMCQAAAAAAAAAAAAAAAB4BppY7LqMFWGlcuYwWoHk+cBklgLZ+ET7GwDuAtn4RPsbAO4C2fhE+xqASgMnFU9s5ye2wez+Ux723xRehax/7dlu5+45/vQMm6m3bS2/tp6F7dG8wI7C0fWlPz98vXD3qDfIMmF49s17/oXTxqqkn6EOwvpmVAixsZeE/BQ46d6UAqgUNMD6fDp0D7Wzg8v38qydYgNrGxeti1/f7NjrXcqnPRagnWAD9JrjOH21mrfuppmuqqSdIAG3txtHNl8921dRTxRhUDjBWS/+klzdCAAAAAAAAAAAAAAAAAMCvAPinKAAAAAAAAAAAAAAAAESVL+ZlHmz00ajTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Somalia.png
// module id = txTS
// module chunks = 0 62 63